import { useEffect } from "react";

// track user interaction via clarity without setting cookies
export const useLinkedIn = (hasConsent: boolean) => {
    useEffect(() => {
        // @ts-ignore
        const _linkedin_partner_id = "7192505";
        // @ts-ignore
        window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
        // @ts-ignore
        window._linkedin_data_partner_ids.push(_linkedin_partner_id);
        // @ts-ignore
        (function (l) {
            if (!l) {
                // @ts-ignore
                window.lintrk = function (a, b) {
                    // @ts-ignore
                    window.lintrk.q.push([a, b]);
                };
                // @ts-ignore
                window.lintrk.q = [];
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            // @ts-ignore
            s.parentNode.insertBefore(b, s);
            // @ts-ignore
        })(window.lintrk);
    }, []);
};
